import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, ActivationStart, EventType, Router } from "@angular/router";
import { BehaviorSubject, filter, Observable } from "rxjs";
import { filterDefined } from "../utils/rxjs";

@Injectable({
  providedIn: "root",
})
export class RouteService {
  private _activatedSnapshot = new BehaviorSubject<ActivatedRouteSnapshot | null>(null);

  constructor(private _router: Router) {
    this._router.events.pipe(filter((event) => event.type === EventType.ActivationStart)).subscribe((event: ActivationStart) => {
      this._activatedSnapshot.next(event.snapshot);
    });
  }

  public get activatedSnapshot(): Observable<ActivatedRouteSnapshot> {
    return this._activatedSnapshot.pipe(filterDefined());
  }
}
